export const MAX_WORD_EXPORT_IMAGES = 5;
export const STUDY_ALIAS_MAX_LENGTH = 20;
export const STUDY_ALIAS_TIMEOUT_MS = 5000;

export const WORD_TEMPLATE_CONTENT_STORAGE_KEY = 'custom_template_docx_base64';
export const WORD_TEMPLATE_NAME_STORAGE_KEY = 'custom_template_docx_name';

const INVALID_FILE_NAME_CHARACTERS = new Set([
  '<',
  '>',
  ':',
  '"',
  '/',
  '\\',
  '|',
  '?',
  '*',
]);

const isInvalidFileNameCharacter = (character) =>
  character.codePointAt(0) < 32
  || INVALID_FILE_NAME_CHARACTERS.has(character);

const sanitizeFileNameBase = (value) => {
  const sanitized = Array.from(String(value ?? ''))
    .map((character) => (
      isInvalidFileNameCharacter(character) ? '_' : character
    ))
    .join('')
    .replace(/_+/g, '_')
    .replace(/^[.\s]+|[.\s]+$/g, '');

  return sanitized || 'заключение';
};

export const normalizeStudyAlias = (value) => {
  const normalized = String(value ?? '').trim();

  if (
    !normalized
    || normalized.length > STUDY_ALIAS_MAX_LENGTH
    || Array.from(normalized).some(isInvalidFileNameCharacter)
  ) {
    return '';
  }

  return normalized;
};

const buildPatientNameFilePart = (patientName) => {
  const words = String(patientName ?? '').trim().split(/\s+/).filter(Boolean);

  if (words.length === 0) {
    return 'заключение';
  }

  if (words.length === 1) {
    return words[0];
  }

  return words.length >= 3
    ? `${words[0]}_${words[1][0]}.${words[2][0]}`
    : `${words[0]}_${words[1][0]}`;
};

export const buildWordExportFileName = ({
  patientName,
  studyAlias,
  contrastType,
  studyDate,
} = {}) => {
  const fileNameParts = [
    buildPatientNameFilePart(patientName),
    normalizeStudyAlias(studyAlias),
    String(contrastType ?? '').trim().toLocaleLowerCase('ru-RU')
      === 'с контрастированием'
      ? 'КУ'
      : '',
    String(studyDate ?? '').trim(),
  ].filter(Boolean);

  return `${sanitizeFileNameBase(fileNameParts.join('_'))}.docx`;
};
